import { RubleSymbol } from '@r1-frontend/ui-react/experimental/purchase/cost/Cost/RubleSymbol';

import * as S from './styled';

// @todo for the children we should to receiving only the "number" type for formatting and displaying cost by human view here. For example: incoming 10000.0, displaying 10 000.00
// on the other hand children may be a ReactNode or a JSX.Element. By my opinion the type "number" is enough
//
// We have to think about it ;-)
export type TCostProps = {
    children: string | number,
    isMonthly?: boolean,
    previousCost?: string | number,
};

/**
 * @deprecated
 * use @r1-frontend/ui-react/components/costs
 */
const Cost = ({ children, isMonthly = false, previousCost, ...props }: TCostProps): JSX.Element => {
    return <S.CostWrapper {...props}>
        {previousCost ? <><S.PreviousCost>{previousCost} {RubleSymbol}{isMonthly && '/мес'}</S.PreviousCost>&nbsp;</> : null}
        {children}&nbsp;{RubleSymbol}{isMonthly && '/мес'}
    </S.CostWrapper>;
};

export default Cost;
